/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
// import { SessionManager } from '@microsoft/applicationinsights-properties-js';
import { isString, objDefineAccessors } from "@microsoft/1ds-core-js";
var Session = /** @class */ (function () {
    function Session() {
    }
    Session.prototype.setId = function (id) {
        this.customId = id;
    };
    Session.prototype.getId = function () {
        if (isString(this.customId)) {
            return this.customId;
        }
        else {
            return this.automaticId;
        }
    };
    /**
     * Static constructor, attempt to create accessors
     */
    Session._staticInit = (function () {
        // Dynamically create get/set property accessors
        objDefineAccessors(Session.prototype, "id", Session.prototype.getId, Session.prototype.setId);
    })();
    return Session;
}());
export { Session };
//# sourceMappingURL=Session.js.map